/**
 * WirisstimulusEmptyValidator class is responsible for validating whether the content of a model is empty.
 * It uses Angular's $injector to get the $translate service for localization.
 */
class WirisstimulusEmptyValidator {
    /**
     * Constructor initializes the validator with dependencies and sets up initial state.
     * @param {Object} $injector - Angular's injector service.
     * @param {Object} model - The model to be validated.
     */
    constructor($injector, model) {
        this.$injector = $injector;
        this.model = model;
        this._translate = null;
        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.EMPTY.WIRIS-STIMULUS';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Lazy loads the $translate service using Angular's $injector.
     * @returns {Object} - The $translate service.
     */
    get $translate() {
        if (!this._translate) {
            this._translate = this.$injector.get('$translate');
        }
        return this._translate;
    }

    /**
     * Validates the model to check if its content is empty.
     * @param {string} from - The source from which the validation is triggered.
     * @returns {Object} - An object containing validation details.
     */
    validate(from) {
        let isError = this.model.isContentEmpty();

        // If the model is empty and has no parents, it is not considered an error.
        if (isError && this.model.getParents().length === 0) {
            isError = false;
        }

        return {
            onSheetBlur:      false,
            onlyBanner:       false,
            validator:        this.getValidatorName(),
            modelUUID:        this.model.getUUID(),
            error:            isError,
            status:           isError ? 'DANGER' : 'SUCCESS',
            message:          this.getErrorMessage(),
            message_template: false,
            callbacks:        [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };
    }

    /**
     * Constructs and returns the error message for the validation.
     * @returns {string} - The error message.
     */
    getErrorMessage() {
        const questionHeadline = this.model.getQuestionHeadline();
        this._message = this.$translate.instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Getter for the forced check flag.
     * @returns {boolean} - The value of the forced check flag.
     */
    get forcedCheck() {
        return this._forced_check;
    }

    /**
     * Returns the name of the validator.
     * @returns {string} - The name of the validator.
     */
    getValidatorName() {
        return 'WirisstimulusEmptyValidator';
    }
}

export default WirisstimulusEmptyValidator;